module.exports = __webpack_public_path__ + "static/media/btn-arrow-back.c4d2a5f8.svg";